// Modal informacyjny po klinięciu "Zapisz wersję roboczą".

import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';

interface IProps {
  open: boolean;
  isCreating?: boolean;
  onClose: () => void;
  onCreateNewVersion?: () => void;
}

const SaveDraftVersionModal: React.FC<IProps> = ({
  open,
  isCreating = false,
  onClose,
  onCreateNewVersion
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={isCreating ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('Zapisz wersję roboczą')}</DialogTitle>
      <DialogContent>
        <p>
          {t(
            'Dane oferty są aktualizowane na bieżąco dla obecnej wersji - Twoje zmiany są już zapisane.'
          )}
        </p>
        <p>
          {t(
            'Jeśli chcesz zachować obecny stan jako osobną wersję historyczną, możesz utworzyć nową wersję oferty.'
          )}
        </p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isCreating}>
          {t('Zamknij')}
        </Button>
        {onCreateNewVersion && (
          <Button
            onClick={onCreateNewVersion}
            variant="contained"
            color="primary"
            disabled={isCreating}>
            {isCreating ? <CircularProgress size={18} /> : t('Utwórz nową wersję')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default SaveDraftVersionModal;
